import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';

import {Header} from 'semantic-ui-react';

import PortfolioNotifications from './Notifications';
import Home from './Home';
import Planet from '../../scene-planet';
import Reddit from '../../client-reddit';

class PortfolioContent extends Component {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        // console.log('PortfolioContent render');
        const {routes} = this.props;
        return <Switch>
            <Route exact={true} path={`${routes.portfolio}/`} component={Home}/>
            <Route component={PortfolioNotifications} path={`${routes.portfolio}/notifications`}/>
            <Route component={Reddit.Content} path={routes.clientReddit}/>
            <Route component={Planet.Content} path={routes.scenePlanet}/>
            <Route>
                <Header as='h1'>Page Not Found</Header>
            </Route>
        </Switch>;
    }
}

export default connect(({routes}) => ({routes}))(PortfolioContent);


// WEBPACK FOOTER //
// ./src/apps/portfolio/components/Content.js